// Imports
import React, { useState, useEffect, useRef } from 'react';
import { createChart } from 'lightweight-charts';
// Styles
import '../styles/FairTrade.css';
// Services
const Routes = require("./../services/routes.js");

function FairTrade() {
  // State variables
  const [stockPrice, setStockPrice] = useState(500);
  const [quantity, setQuantity] = useState(0);
  const [playerCash, setPlayerCash] = useState(10000);
  const [playerInventory, setPlayerInventory] = useState(0);
  const [equity, setEquity] = useState(playerCash + (stockPrice * playerInventory));
  const [cumulativeFee, setCumulativeFee] = useState(0);
  const [endpointUrl, setEndpointUrl] = useState(Routes.getWebsocketURL());
  const [socket, setSocket] = useState(null);

  // todo move to server
  const stdDev = 5;

  const chartContainer = useRef(null);
  let chart;
  let lineSeries;

  useEffect(() => {
    chart = createChart(chartContainer.current, {
      timeScale:{
        timeVisible:true,
        secondsVisible:false,
      }
    });

    lineSeries = chart.addLineSeries();

    // Setup websocket
    try{
      console.log(`Setup websocket at ${endpointUrl}`);
      const newSocket = new WebSocket(endpointUrl);
      newSocket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        updatePrice(data);
      };
      newSocket.onopen = () => {
        console.log('Connection opened');
      };
      newSocket.onerror = (event) => {
        console.error(`Websocket error: ${event.message}`);
      };
      newSocket.onclose = (event) => {
        console.log(`Websocket closed. Code:${event.code} Reason:${event.reason}`);
      };
      setSocket(newSocket);
    }
    catch(err){
      console.error(`Failed to create websocket (${endpointUrl}): ${err}`);
    }

    return () => {
      // Safely close the candle chart
      if (chart && typeof chart.remove === 'function'){
        chart.remove();
      }

      // Close the websocket if not already
      if (socket && socket.readyState === WebSocket.OPEN){
        socket.close();
      }
    };
  }, []);

  // Function to print current stock price, time/date, open, high, low, and close prices
  function updatePrice({stockPrice, openPrice, closePrice, highPrice, lowPrice, currentTime}) {
    const updateEquity = playerCash + (stockPrice * playerInventory);
    
    //liquidation
    if (updateEquity < Math.abs(playerInventory)*(stdDev*4) && playerInventory < 0) {
      let sharesToBuy = -1 * playerInventory;
      buyStock(sharesToBuy);
      //console.log(`Cashed out short position of ${sharesToBuy} shares.`);
    }  
    else if (updateEquity < playerInventory * (stdDev*4) && playerInventory > 0) {
      let sharesToSell = playerInventory;
      sellStock(sharesToSell);
      //console.log('Cashed out of long poistion.');
    }
     
    const stockData = {
      time: Date.now()/1000,      
      value: closePrice.toFixed(2)
    };

    // Update state
    lineSeries.update(stockData);
    setEquity(updateEquity);
    setStockPrice(stockPrice);
  }

  function buyStock(quantity) {    
    if (quantity > (equity / (4 * stdDev)) - playerInventory) {
      console.log("Max bet threshold");
      return;
    } 
    
    let tradingFee = (stockPrice * quantity) * 0.001;
    const updateCash = playerCash - stockPrice * Math.abs(quantity) + tradingFee;
    const updatePlayerInventory = playerInventory + parseInt(quantity);
    const updateEquity = updateCash + (stockPrice * updatePlayerInventory); // calculate equity
    console.log(`Bought ${quantity} shares at $${stockPrice} each.`);
    console.log(`Equity: $${updateEquity}`); // display equity
    displayTransaction('buy',quantity,stockPrice);
    
    // Update state
    setPlayerCash(updateCash);
    setPlayerInventory(updatePlayerInventory);
    setEquity(updateEquity);
    setCumulativeFee(cumulativeFee + tradingFee);
  }

  function sellStock(quantity) {
    if (Math.abs(playerInventory - quantity) > equity / (4 * stdDev)) {
      console.log("Max bet threshold");
      return;
    }
    
    let tradingFee = (stockPrice * quantity) * 0.001;
    const updateCash = playerCash + stockPrice * Math.abs(quantity) - tradingFee;
    const updatePlayerInventory = playerInventory - quantity;
    const updateEquity = updateCash + (stockPrice * updatePlayerInventory); // calculate equity
    console.log(`Sold ${quantity} shares at $${stockPrice} each.`);
    console.log(`Equity: $${updateEquity}`); // display equity
    displayTransaction('sell',quantity,stockPrice);
    
    // Update state
    setPlayerCash(updateCash);
    setPlayerInventory(updatePlayerInventory);
    setEquity(updateEquity);
    setCumulativeFee(cumulativeFee + tradingFee);
  }

  function displayTransaction(transactionType,quantity,price) {
    console.log(`Transaction type: ${transactionType}`);
    console.log(`Quantity: ${quantity}`);
    console.log(`Price: ${price}`);
  }

  return (
    <div className="fair-trade">
      {/* Chart */}
      <div ref={chartContainer} style={{ width: '100%', height: '600px' }} />

      <div>
        {/* Input */}
        <form>
          <label htmlFor="quantity">Quantity:</label>
          <input type="number" name="quantity" value={quantity} onChange={(event)=>setQuantity(event.target.value)} />
        </form>

        {/* Buy Sell Buttons */}
        <div>
          <button type="button" onClick={()=>buyStock(quantity)}>Buy shares</button>
          <button type="button" onClick={()=>sellStock(quantity)}>Sell shares</button>
        </div>

        {/* Asset Info */}
        <ul className='assets'>
          <li>Cash: ${playerCash.toFixed(2)}</li>
          <li>Portfolio: {playerInventory} shares</li>
          <li>Equity Value: ${equity.toFixed(2)}</li>
          <li>Cumulative Fee: ${cumulativeFee.toFixed(2)}</li>
          <li>Liquidation Threshold: {Math.abs(equity / (stdDev * 4 * playerInventory)*100).toFixed(0)} %</li>
          <li>Current stock price: ${stockPrice.toFixed(4)}</li>
        </ul>
      </div>
    </div>
  );
}

export default FairTrade;
